import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { RoleService } from '@services/roles/role.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss'],
    providers: [RoleService],
    standalone: false
})

export class RolesComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public title = 'Roles';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'name' }
  ];

  constructor(
    public roleService: RoleService,
    private router: Router,
    private dialogService: DialogService,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Role',
        callback: () => {
          this.router.navigate(['roles/create']);
        }
      })
    ];
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['roles', event.row.RoleID]);
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['roles', event.row.RoleID, 'edit']);
  }

  public onRemove(event: DataTableEvent): void {
    this.dialogService.confirm('Delete this role and assigend privileges ?')
      .then(res => {
        if (!res) {
          return;
        }
        return this.roleService.remove(event.row.RoleID).then(() => {
          this.dataTable.refresh();
          this.snackbar.success('Role removed');
        }, error => {
          const message = (error.error.message ? error.error.message : error.message);
          console.error(error);
          return this.dialogService.confirm(message, error.name);
        });
      });
  }
}
